import { z } from 'zod';

import { ReverificationSubmitFormFields, ReverificationSubmitFormValues } from '../types';

export const reverificationSubmitFormValidationSchema = z.object({
  [ReverificationSubmitFormFields.paymentMethodId]: z.string().nullish(),
}) satisfies z.ZodType<ReverificationSubmitFormValues>;
